import icons from './icondef.json';

const container = document.createElement('span');
container.style.display = 'none';
container.innerHTML = icons.def;
document.body.appendChild(container);
